export const processList = (state, rootState) => {
	return state.processList;
}

export const objProcessEdit = (state, rootState) => {
	return state.objProcessEdit;
}

export const formValid = (state, rootState) => {
  return state.formValid;
}

export const commercialKams = (state, payload) => {
  return state.commercialKams;
}

export const commercialOriginators = (state, payload) => {
  return state.commercialOriginators;
}

export const generatedLink = (state, payload) => {
  return state.generatedLink;
}

export const erfNumbers = (state, payload) => {
  return state.erfNumbers;
}